<template>
    <v-dialog v-model="display" max-width="1000">
        <v-card>
            <v-card-title />
            <v-card-text class="text-center" v-html="text" />
            <v-card-actions class="justify-center">
                <v-btn variant="flat" @click="display = false">
                    {{ $t('close') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'
    import {EventBus, SHOW_NOTIFICATION_MODAL} from '@/utils/event-bus'

    @Component
    export class NotificationModal extends Vue {
        display = false
        text = null

        mounted() {
            EventBus.$on(SHOW_NOTIFICATION_MODAL, this.show)
        }

        beforeUnmount() {
            EventBus.$off(SHOW_NOTIFICATION_MODAL, this.show)
        }

        show(text) {
            this.text = text
            this.display = true
        }
    }

    export default NotificationModal
</script>
